import styled from "@emotion/styled";
import { Container, Typography } from "@mui/material";
import { Grid } from "@mui/material";

const HeaderContainer = styled(Container)`
    min-height:100vh;
    display: flex;
    align-items: center;
    padding-left:0px !important;
    padding-right:0px !important;

`
const WrapperContainer = styled(Grid)`

`
const ContentWrapper = styled(Grid)`
    background-image: linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0));
    padding:80px 100px;
    @media (max-width: 749px){
        padding:40px 20px; 
    }
    @media (max-width: 1024px) and (min-width: 750px){
        padding:30px 40px; 
    }
    @media (max-width: 1400px) and (min-width: 1025px){
        padding:50px 60px; 
    }
`
const VideoBK = styled.video`
    object-fit: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
    z-index: -1;
`
const P = styled.p`
    color:#fff;
    font-size:15px;
    font-family:poppins;
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:80px;
    font-family:Oswald-bold;
    text-transform:uppercase;
`
const BuyBtn = styled.a`
    color:#fff;
    background-image: linear-gradient(to right, #D5312F, #700100);
    font-size:18px;
    font-family:Oswald;
    padding:8px 40px 10px 40px;
    border-radius:10px;
    @media(max-width: 600px){
        font-size:16px;
        padding: 6px 35px 10px 35px;
    }
    @media(max-width: 900px) and (min-width: 750px){
        margin-top:0px;
    }
`
const ChartBtn = styled.a`
    color:#fff;
    background-image: linear-gradient(to right, #2B2B2B, #000000);
    font-size:18px;
    font-family:Oswald;
    padding:8px 40px 10px 40px;
    margin-left:20px;
    border-radius:10px;
    @media(max-width: 600px){
        font-size:16px;
        padding: 6px 35px 10px 35px;
    }
    @media(max-width: 900px) and (min-width: 750px){
        margin-top:0px;
    }
`
const BtnGrid = styled(Grid)`
    margin-top:30px;
    display:flex;
`


function Header(){
    return(
        <>
            <VideoBK autoPlay loop muted>
            <source src="./assets/gear 5_x264_001.mp4" type="video/mp4" />
            </VideoBK>
            <HeaderContainer maxWidth="xxl" id="home">
                <WrapperContainer container>
                    <ContentWrapper item xs={12} sm={8} md={6}>
                        <Heading variant="h1">Luffy</Heading>
                        <P>Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                             sed diam nonumy eirmod tempor invidunt ut labore et dolore
                              magna aliquyam erat, sed diam voluptua. 
                        </P>
                        <BtnGrid item xs={12}><BuyBtn>Buy Now</BuyBtn><ChartBtn>Buy Now</ChartBtn></BtnGrid> 
                    </ContentWrapper>
                </WrapperContainer>
            </HeaderContainer>
        </>
    );
}

export default Header;